// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2meRz","head":"Table_head__2BvkI","col":"Table_col__1JXRt"};